module.exports = __webpack_public_path__ + "static/media/icon-quartos-black.b1fdcef9.svg";